import React from 'react'
import { JumboImage } from '@/components/JumboImage'
import './index.css'

type JumbotronProps = {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export const Jumbotron = ({ className = '', style }: JumbotronProps) => (
  <div className={`Jumbotron--root ${className}`} style={style}>
    <JumboImage />
  </div>
)
